"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Validate = exports.Normalize = exports.Encode = exports.Decode = exports.Format = exports.ErrBadChar = exports.ErrNoValues = exports.ErrTooManyValues = exports.ErrEmptyName = exports.ErrUnsuportedFormat = exports.ErrVersionChange = void 0;
exports.ErrVersionChange = { name: 'ErrVersionChange', message: 'version change' };
exports.ErrUnsuportedFormat = { name: 'ErrUnsupportedFormat', message: 'unsupported format' };
exports.ErrEmptyName = { name: 'ErrEmptyName', message: 'empty name' };
exports.ErrTooManyValues = { name: 'ErrTooManyValues', message: 'more than one value in the record' };
exports.ErrNoValues = { name: 'ErrNoValues', message: 'no value or sum field found' };
exports.ErrBadChar = { name: 'ErrBadChar', message: 'invalid char' };
const defaultVersion = 10;
var Format;
(function (Format) {
    Format[Format["JSON"] = 1] = "JSON";
    Format[Format["XML"] = 2] = "XML";
    Format[Format["CBOR"] = 3] = "CBOR";
})(Format = exports.Format || (exports.Format = {}));
// Encode takes a SenML Pack and encodes it using the given format.
function Decode(msg, format) {
    const p = { Records: [] };
    switch (format) {
        case Format.JSON:
            p.Records = JSON.parse(msg);
            break;
        default:
            return exports.ErrUnsuportedFormat;
    }
    const err = Validate(p);
    if (err !== null) {
        return err;
    }
    return p;
}
exports.Decode = Decode;
// Encode takes a SenML Pack and encodes it using the given format.
function Encode(p, format) {
    switch (format) {
        case Format.JSON:
            return JSON.stringify(p.Records);
        default:
            return exports.ErrUnsuportedFormat;
    }
}
exports.Encode = Encode;
// Normalize removes all the base values and expands records values with the base items.
// The base fields apply to the entries in the Record and also to all Records after
// it up to, but not including, the next Record that has that same base field.
function Normalize(p) {
    const err = Validate(p);
    if (err !== null) {
        return err;
    }
    let bname = '';
    let btime = 0;
    let bsum = 0;
    let bunit = '';
    const records = [];
    for (const r of p.Records) {
        if (r.bt && r.bt !== 0)
            btime = r.bt;
        if (r.bs && r.bs !== 0)
            bsum = r.bs;
        if (r.bu && r.bu !== '')
            bunit = r.bu;
        if (r.bn && r.bn.length > 0)
            bname = r.bn;
        if (r.t && btime)
            r.t = r.t + btime;
        r.n = bname + r.n;
        if (r.s && bsum)
            r.s = bsum + r.s;
        if ((!r.u || r.u === '') && bunit)
            r.u = bunit;
        if (r.v && r.bv && r.bv !== 0)
            r.v = r.bv + r.v;
        // If the version is default, it must not be present in resolved records.
        // Validate method takes care that the version is the same on all the records.
        if (r.bv === defaultVersion)
            r.bv = 0;
        // Remove Base Values from the Record.
        r.bt = 0;
        r.bv = 0;
        r.bu = '';
        r.bn = '';
        r.bs = 0;
        // Add to the SenML array
        records.push(r);
    }
    p.Records = records;
    // TODO: Need to sort
    return p;
}
exports.Normalize = Normalize;
// Validate validates SenML records.
function Validate(p) {
    let bver = 0;
    let bname = '';
    let bsum = 0;
    for (const r of p.Records) {
        // Check if version is the same for all the records.
        if ((!bver || bver === 0) && r.bver && r.bver !== 0) {
            bver = r.bver;
        }
        if (bver !== 0 && (!r.bver || r.bver === 0)) {
            r.bver = bver;
        }
        if (r.bver && r.bver !== bver) {
            return exports.ErrVersionChange;
        }
        if (r.bn && r.bn !== '')
            bname = r.bn;
        if (r.bs && r.bs !== 0)
            bsum = r.bs;
        const name = bname + r.n;
        if (name.length === 0)
            return exports.ErrEmptyName;
        let valCnt = 0;
        if (r.v)
            valCnt++;
        if (r.vb)
            valCnt++;
        if (r.vd)
            valCnt++;
        if (r.vs)
            valCnt++;
        if (valCnt > 1)
            return exports.ErrTooManyValues;
        if (r.s || bsum !== 0)
            valCnt++;
        if (valCnt < 1)
            return exports.ErrNoValues;
        const err = validateName(name);
        if (err != null) {
            return err;
        }
    }
    return null;
}
exports.Validate = Validate;
function validateName(name) {
    const l = name[0];
    if (l === '-' || l === ':' || l === '.' || l === '/' || l === '_') {
        return exports.ErrBadChar;
    }
    for (const l of name) {
        if ((l < 'a' || l > 'z') &&
            (l < 'A' || l > 'Z') &&
            (l < '0' || l > '9') &&
            l !== '-' &&
            l !== ':' &&
            l !== '.' &&
            l !== '/' &&
            l !== '_') {
            return exports.ErrBadChar;
        }
    }
    return null;
}
